"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AeridynesSpringAbilityHandler = exports.AeridynesSpringActorAbilityFactory = exports.AeridynesSpringAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Regeneration_1 = require("../../core/effects/core/Regeneration");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class AeridynesSpringAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.AeridynesSpring;
        this.__typeName = "AeridynesSpring";
    }
}
exports.AeridynesSpringAbilityArgs = AeridynesSpringAbilityArgs;
let AeridynesSpringActorAbilityFactory = class AeridynesSpringActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("AeridynesSpring", "AllAllies", 2);
    }
};
AeridynesSpringActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("AeridynesSpring")
], AeridynesSpringActorAbilityFactory);
exports.AeridynesSpringActorAbilityFactory = AeridynesSpringActorAbilityFactory;
let AeridynesSpringAbilityHandler = class AeridynesSpringAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(targetId => {
                    container.applyBuff({
                        sequence: sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "DivineHealingWinds")),
                        creatorId: ability.invokerId,
                        targetId,
                        duration: Duration_1.Duration.Turns(5),
                        effect: new Regeneration_1.RegenerationEffectArgs("AeridynesSpring", container.getPercentOfBaseHealth(targetId, 2)),
                    });
                });
            }
        });
    }
};
AeridynesSpringAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.AeridynesSpring)
], AeridynesSpringAbilityHandler);
exports.AeridynesSpringAbilityHandler = AeridynesSpringAbilityHandler;
